import { useCallback } from 'react';

import { TServerSendResponse } from '../../types';
import { useGenericSend } from '../useGenericSend';
import * as Types from './types';

export const useOptOutFromBonusTemplate = () => {
    const send = useGenericSend();

    return useCallback(async (request: Types.IOptOutFromBonusTemplateRequestData): Promise<TServerSendResponse> => {
        const { data } = await send<Types.IOptOutFromBonusTemplateRequestData, TServerSendResponse>({
            ID: 31094,
            responses: [31095, 31096],
            description: 'Opt out from bonus template',
            errorLevel: 1,
            ...request
        });

        return data;
    }, [
        send
    ]);
};
